module.exports = __webpack_public_path__ + "static/media/darryl_baker.af2da40a.jpeg";